import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ContactCard({ icon, title, description, contact }) {
  return (
    <a
      href={contact}
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-col justify-center p-6 bg-darkMode-layer1 rounded-2xl shadow-md hover:shadow-lg hover:bg-darkMode-layer2 transition-all duration-300 w-full sm:max-w-sm cursor-pointer group"
    >
      <div className="flex items-center justify-center w-12 h-12 bg-darkMode-layer2 rounded-full group-hover:bg-darkMode-layer1">
        <FontAwesomeIcon icon={icon} className="text-darkMode-green text-lg" />
      </div>
      <h3 className="mt-4 text-xl font-semibold text-darkMode-text">{title}</h3>
      <p className="mt-2 text-sm text-darkMode-text opacity-80">
        {description}
      </p>
      <span className="mt-4 text-darkMode-green text-sm font-medium">
        Contact Now →
      </span>
    </a>
  );
}
